import {
  listCategory
  // , getInfo
} from '@/api/post'
// import { getToken, setToken, removeToken, getUserId, setUserId, removeUserId } from '@/utils/auth'
// import { resetRouter } from '@/router'

const state = {
  categories: []
}

const mutations = {
  SET_CATEGORIES: (state, categories) => {
    state.categories = categories ? categories.slice() : []
  }
}

const actions = {
  // user login
  listCategory ({ commit }) {
    // console.log('in store action')
    return new Promise((resolve, reject) => {
      listCategory().then(response => {
        // console.log('listCategory response', response.data.items)
        const items = response.data.items
        // data.id = parseInt(data.id)
        commit('SET_CATEGORIES', items)
        // commit('SET_USER_ID', data.id)
        // setToken(data.token)
        // setUserId(data.id)
        resolve(items)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
